import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 bg-navy-900 relative" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="bg-navy-800 rounded-3xl p-8 sm:p-12 shadow-2xl border border-navy-800/50 relative overflow-hidden" data-id="element-80">
          {/* Subtle accent line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500/0 via-cyan-500 to-cyan-500/0 opacity-50" data-id="element-81" />

          <h2 className="font-heading text-3xl sm:text-4xl text-white mb-8 leading-tight" data-id="element-82">
            ¿Te despiertas a las <span className="text-cyan-400" data-id="element-83">3:00 AM</span>{' '}
            con la mente acelerada, repasando tu lista de pendientes?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 font-body leading-relaxed" data-id="element-84">
            <p data-id="element-85">
              No es falta de voluntad.{' '}
              <span className="text-white font-medium" data-id="element-86">
                Es un secuestro químico.
              </span>
            </p>
            <p data-id="element-87">
              Tu cuerpo está produciendo{' '}
              <span className="text-amber-400 font-medium" data-id="element-88">
                cortisol en el momento equivocado
              </span>
              , activando tu modo de "supervivencia" cuando deberías estar
              reparando tus células.
            </p>
            <p className="pl-4 border-l-2 border-cyan-500/50 text-slate-200 italic" data-id="element-89">
              Si no reseteas este ciclo, ningún café por la mañana te devolverá
              la energía que estás perdiendo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}